import moment from 'moment'

const states = {
  reports_details: {
    reports: [],
    selected_report: {
      report_item: null,
      filters: [],
      table_data: [],
      table_columns: [],
      current_page: 0,
      has_more_pages: false,
      page_scanned_ids: {}
    },
    selected_filters: {
      startDate: moment(new Date(), "DD-MM-YYYY").subtract(1, "days"),
      endDate: moment(new Date(), "DD-MM-YYYY")
    },
    reports_loading: false,
    requested_reports_loading: false
  }
}

export default states



// WEBPACK FOOTER //
// ./src/data/redux/reports_details/states.js